import { render } from "./AddPortARisqueModal.vue?vue&type=template&id=3c3887ee&ts=true"
import script from "./AddPortARisqueModal.vue?vue&type=script&lang=ts"
export * from "./AddPortARisqueModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__